import { useEffect, useState } from "react";
import useQuery from "../utils/UseQuery";
import { ClipLoader } from "react-spinners";
import { ButtonStyle } from "../utils/Buttons/Buttons";
import { infoMessage } from "../api/errorHandler";
import { ConstructionOutlined } from "@mui/icons-material";
import { TextFieldStyleDummies } from "../utils/TextFieldStyle/TextFieldStyle";
import {
  coreIdCallback,
  canContinue,
  getColorsByCodeId,
  getColorsByExecFlow,
  magicFormsCallback,
} from "./hyperFlowApi";
import { useHistory } from "react-router-dom";

const HyperFlowMagicFormsCallback = () => {
  let history = useHistory();
  //query params
  const query = useQuery();
  const execFlowId = query.get("execFlowId") ?? "error";
  const filledFormId = query.get("filledFormId") ?? "error";
  const stepId = query.get("stepId") ?? "error";
  const code = query.get("code") ?? "error";
  //State selectors

  //local states
  const [bgColor, setBgColor] = useState(["#ffffff", "#ffffff"]);
  const [loading, setLoading] = useState(false);
  const [darkMode, setDarkMode] = useState(true);

  //get colors
  async function getColors() {
    let resp = await getColorsByExecFlow(execFlowId);
    setBgColor([resp.backgroundColor1, resp.backgroundColor2]);
    setDarkMode(resp.darkMode);
  }

  async function magicFormsCallbackF() {
    setLoading(true);
    try {
      await magicFormsCallback(filledFormId, execFlowId, stepId);
    } catch (e: any) {
      console.log(e);
    }
    await delay(3000);
    // setLoading(false);
    history.push("/hyperFlow/continueFlow?code=" + code);
  }

  function delay(ms: number) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  useEffect(() => {
    getColors();
    magicFormsCallbackF();
  }, []);

  const customStyle = {
    "--fontColorPrimary": darkMode ? "#ffffff" : "#000000",
  } as React.CSSProperties;

  //Render
  return (
    <div className="hfMaster" style={customStyle}>
      <div
        style={{
          background: `radial-gradient(${bgColor[0]}, ${bgColor[1]})`,
          position: "fixed",
          height: "100%",
          width: "100%",
          overflow: "auto",
        }}
      >
        <div
          style={{
            position: "absolute",
            top: "50%",
            transform: "translate(-50%, -50%)",
            left: "50%",
          }}
        >
          {loading && (
            <div>
              <h1
                className="txt-label-title-hf"
                style={{ fontSize: "22px", marginBottom: "50px" }}
              >
                Espera un momento por favor
              </h1>
              <ClipLoader
                color={darkMode ? "#ffffff" : "#000000"}
                size={"120px"}
                loading={true}
              />
              <h1
                className="txt-label-title-hf"
                style={{ fontSize: "22px", marginBottom: "50px" }}
              >
                Estamos finalizando tu formulario
              </h1>
            </div>
          )}

          {!loading && (
            <div>
              <h1
                className="txt-label2"
                style={{ fontSize: "", marginBottom: "50px" }}
              >
                Tus datos están completos
              </h1>
              <h1
                className="txt-label2"
                style={{ fontSize: "", marginBottom: "50px" }}
              >
                Continuemos con tu proceso
              </h1>
              <div
                style={{
                  marginTop: "40px",
                }}
              ></div>
              <ButtonStyle
                onClick={() => {
                  history.push("/hyperFlow/continueFlow?code=" + code);
                }}
                text="Continuar"
                width="177px"
                height="5vh"
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default HyperFlowMagicFormsCallback;
